// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var GET_DOCUMENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetDocument($id: uuid, $tenantId: uuid) {\n        sequent_backend_document(where: {_and: {tenant_id: {_eq: $tenantId}, id: {_eq: $id}}}) {\n            name\n        }\n    }\n"], ["\n    query GetDocument($id: uuid, $tenantId: uuid) {\n        sequent_backend_document(where: {_and: {tenant_id: {_eq: $tenantId}, id: {_eq: $id}}}) {\n            name\n        }\n    }\n"])));
var templateObject_1;
